import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../../redux/store';
import moment from 'moment';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    children: React.ReactNode;
	vesselId: string;
};
type ORB4CoverPageProps = PropsFromRedux & OwnProps;
function ORB4CoverPage(props: ORB4CoverPageProps) {
    const {
        dateRange,
        vesselName,
        imoNumber,
        distinctiveNumberOrLetters,
        children,
    } = props;

    return (
        <div>
            {/* First Page */}
            <div className="flex flex-col justify-between px-8 py-4 mb-2">
                <div className="mx-0 my-24 text-xl font-medium text-center">
                    <h3 className="uppercase">Oil Record Book</h3>
                    <h4>Part II - Cargo / Ballast Operations</h4>
                    <span className="italic">(Oil Tankers)</span>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">Name of ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {vesselName}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">
                                Distinctive number or letters:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0 self-end">
                                {distinctiveNumberOrLetters}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">IMO Number:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0">
                                {imoNumber}
                            </p>
                        </div>

                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mb-0 mr-2 min-w-fit">
                                Gross tonnage:
                            </p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed text-sm border-[#808080] w-full mb-0 self-end">
                                {props?.tonnage?.grossTonnage || ''}
                            </p>
                        </div>
                        <div
                            className="flex items-center justify-between mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period from :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                    {dateRange?.startDate &&
                                        moment(dateRange?.startDate).format(
                                            'DD-MM-yyyy'
                                        )}{' '}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">to :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                    {dateRange?.endDate &&
                                        moment(dateRange?.endDate).format(
                                            'DD-MM-yyyy'
                                        )}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 text-sm">
                                English
                            </p>
                        </div>
                    </div>
                </div>

                <div className="border p-1 my-4 border-[#2D3748]">
                    Note: Every oil tanker of 150 gross tonnage and above shall
                    be provided with Oil Record Book Part II to record relevant
                    cargo/ballast operations. Such a tanker shall also be
                    provided with Oil Record Book Part I to record relevant
                    machinery space operations.
                </div>
            </div>
            {/* Plan View */}
            <div className="flex flex-col justify-between px-8 py-4 pt-0 mb-2 text-left newpage">
                <div className="mb-4 text-center">
                    <h2 className="text-xl uppercase">
                        Plan view of cargo and slop tanks
                    </h2>
                    <p className="text-lg">(to be completed on board)</p>
                </div>
                <div className="flex flex-col my-8">
                    <div
                        className="flex items-center mb-4"
                        style={{ fontSize: '1.125rem' }}
                    >
                        <p className="mb-0 mr-2 text-base min-w-fit">
                            Name of ship
                        </p>
                        <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                            {vesselName}
                        </p>
                    </div>
                    <div
                        className="flex items-center mb-4"
                        style={{ fontSize: '1.125rem' }}
                    >
                        <p className="mb-0 mr-2 text-base min-w-fit">
                            Distinctive number or letters
                        </p>
                        <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                            {distinctiveNumberOrLetters}
                        </p>
                    </div>
                </div>
                <div>{children}</div>
                {/* <div>
                    <div className="flex items-center justify-center ">
                        <div
                            className="flex items-center justify-center"
                            style={{
                                width: '42%',
                            }}
                        >
                            <img
                                src={cargoSlopTankImg}
                                style={{ height: 380, marginLeft: -70 }}
                                alt="cargo-slop tank view"
                            />
                        </div>
                        <div
                            className="flex flex-col items-center justify-center"
                            style={{
                                width: '46%',
                            }}
                        >
                            <div className="mt-6">
                                {Array.from({ length: 11 }).map((_, i) => {
                                    return (
                                        <div className="flex text-center">
                                            <div
                                                style={{
                                                    width: 165,
                                                    height: 35,
                                                    fontSize: 12,
                                                    border: '0.75px solid',
                                                    borderRight: 0,
                                                    borderBottom:
                                                        i === 10
                                                            ? '0.75px solid'
                                                            : 0,
                                                    padding:
                                                        i === 0
                                                            ? '5px 10px'
                                                            : undefined,
                                                }}
                                            >
                                                {i === 0 ? (
                                                    <b>
                                                        Identification of tanks
                                                    </b>
                                                ) : i === 10 ? (
                                                    'Depth of slop tank(s):'
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                            <div
                                                style={{
                                                    width: 165,
                                                    height: 35,
                                                    fontSize: 12,
                                                    border: '0.75px solid',
                                                    borderBottom:
                                                        i === 10
                                                            ? '0.75px solid'
                                                            : 0,
                                                    padding:
                                                        i === 0
                                                            ? '5px 10px'
                                                            : undefined,
                                                }}
                                            >
                                                {i === 0 ? <b>Capacity</b> : ''}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <p className="my-4 text-xs">
                                (Give the capacity of each tank and the depth of
                                slop tank(s))
                            </p>
                        </div>
                    </div>
                </div> */}
            </div>

            {/* <div className="newpage">{children}</div> */}

            {/* Second Page */}
            <div className="flex flex-col justify-between px-8 py-4 pt-0 mb-2 text-left newpage">
                <h2 className="text-xl font-medium">Introduction</h2>
                <p className="py-2">
                    The following pages of this section show a comprehensive
                    list of items of cargo and ballast operations which are,
                    when appropriate, to be recorded in the Oil Record Book Part
                    II in accordance with regulation 36 of Annex I of the
                    International Convention for the Prevention of Pollution
                    from Ships, 1973, as modified by the Protocol of 1978
                    relating thereto (MARPOL 73/78). The items have been grouped
                    into operational section, each of which is denoted by a code
                    letter.
                </p>
                <p className="py-2">
                    When making entries in the Oil Record Book Part II, the
                    date, operational code and item number shall be inserted in
                    the appropriate columns and the required particulars shall
                    be recorded chronologically in the blank spaces.
                </p>
                <p className="py-2">
                    Each completed operation shall be signed for and dated by
                    the officer or officers in charge. Each completed page shall
                    be countersigned by the master of the ship.
                </p>
                <p className="py-2">
                    In respect of the oil tankers engaged in specific trades in
                    accordance with regulation 2.5 of Annex I of MARPOL 73/78,
                    appropriate entry in the Oil Record Book Part II shall be
                    endorsed by the competent port State authority.*
                </p>
                <p className="py-2">
                    The Oil Record Book Part II contains many references to oil
                    quantity. The limited accuracy of tank Measurement devices,
                    temperature variations and clingage will affect the accuracy
                    of these readings. The entries in the Oil Record Book Part
                    II should be considered accordingly.
                </p>
                <p className="py-2">
                    In the event of accidental or other exceptional discharge of
                    oil a statement shall be made in the Oil Record Book Part II
                    of the circumstances of, and the reasons for, the discharge.
                </p>
                <p className="py-2">
                    Any failure of the oil discharge monitoring and control
                    system shall be noted in the Oil Record Book Part II.
                </p>
                <p className="py-2">
                    The entries in the Oil Record Book Part II, for ships
                    holding an IOPP Certificate, shall be at least in English,
                    French or Spanish. Where entries in an official language of
                    the State whose flag the ship is entitled to fly are also
                    used, this shall prevail in case of a dispute or
                    discrepancy.
                </p>
                <p className="py-2">
                    The Oil Record Book Part II shall be kept in such a place as
                    to be readily available for inspection at all reasonable
                    times and, except in the case of unmanned Ships under tow,
                    shall be kept on board the Ship. It shall be preserved for a
                    period of three years after the last entry has been made.
                </p>
                <p className="py-2">
                    The competent authority of the Government of a Party to the
                    Convention may inspect the Oil Record Book Part II on board
                    any Ship to which this Annex applies while the Ship is in
                    its port or offshore terminals and may make a copy of any
                    entry in that book and may require the master of the Ship to
                    certify that the copy is a true copy of such entry. Any copy
                    so made which has been certified by the master of the Ship
                    as a true copy of an entry in the Oil Record Book Part II
                    shall be made admissible in any juridical proceedings as
                    evidence of the facts stated in the entry. The inspection of
                    an Oil Record Book Part II and taking of a certified copy by
                    the competent authority under this paragraph shall be
                    performed as expeditiously as possible without causing the
                    ship to be unduly delayed.
                </p>
                <div className="mt-8">
                    <div
                        className=" border-[#2D3748] border-[0.5px]  mt-0 mb-3 mx-0"
                        style={{ width: 224 }}
                    />
                    <span>
                        * This sentence should only be inserted for the Oil
                        Record Book of a tanker engaged in a specific trade.
                    </span>
                </div>
            </div>
            {/* Third Page */}
            <div className="px-8 py-0 newpage">
                <h2 className="mb-6 text-2xl font-medium">
                    LIST OF ITEMS TO BE RECORDED
                </h2>
                <ol type="A" className="ml-4 list-alpha">
                    <li className="mb-4">
                        <b>Loading of oil cargo</b>
                        <ol className="ml-4 list-decimal">
                            <li className="mx-0 my-2">Place of loading.</li>
                            <li className="mx-0 my-2">
                                Type of oil loaded and identity of tank(s).
                            </li>
                            <li className="mx-0 my-2">
                                Total quantity of oil loaded (state quantity
                                added, in m³ at 15°C and the total content of
                                tank(s), in m³)
                            </li>
                        </ol>
                    </li>

                    <li className="mb-4">
                        <b>Internal transfer of oil cargo during voyage</b>
                        <ol start={4} className="ml-4 list-decimal">
                            <li className="mx-0 my-2">
                                Identity of tank(s):
                                <ol className="ml-4 list-decimal">
                                    <li className="mx-0 my-2">from:</li>
                                    <li className="mx-0 my-2">
                                        to: (state quantity transferred and
                                        total quantity of tank(s), in m³).
                                    </li>
                                </ol>
                            </li>
                            <li className="mx-0 my-2">
                                Was (were) the tank(s) in 4.1 emptied? (If not,
                                state quantity retained, in m³.)
                            </li>
                        </ol>
                    </li>

                    <li className="mb-4">
                        <b>Unloading of oil cargo</b>
                        <ol className="ml-4 list-decimal" start={6}>
                            <li className="mx-0 my-2">Place of unloading.</li>
                            <li className="mx-0 my-2">
                                Identity of tank(s) unloaded.
                            </li>
                            <li className="mx-0 my-2">
                                Was (were) the tank(s) emptied? (If not, state
                                quantity retained, in m³.)
                            </li>
                        </ol>
                    </li>

                    <li className="mb-4">
                        <b>Crude oil washing (COW tankers only)</b>
                        <p className="m-0">
                            (To be completed for each tank being crude oil
                            washed)
                        </p>
                        <ol className="ml-4 list-decimal" start={9}>
                            <li className="mx-0 my-2">
                                Port where crude oil washing was carried out or
                                ship's position if carried out between two
                                discharge ports.
                            </li>
                            <li className="mx-0 my-2">
                                Identity of tank(s) washed.
                                <sup>1</sup>
                            </li>
                            <li className="mx-0 my-2">
                                Number of machines in use.
                            </li>
                            <li className="mx-0 my-2">
                                Time of start of washing.
                            </li>
                            <li className="mx-0 my-2">
                                Washing pattern employed.<sup>2</sup>
                            </li>
                            <li className="mx-0 my-2">
                                Washing line pressure.
                            </li>
                            <li className="mx-0 my-2">
                                Time washing was completed or stopped.
                            </li>
                            <li className="mx-0 my-2">
                                State method of establishing that tank(s) was
                                (were) dry.
                            </li>
                            <li className="mx-0 my-2">
                                Remarks. <sup>3</sup>
                            </li>
                        </ol>
                    </li>
                </ol>
                <div
                    className=" border-[#2D3748] border-[0.5px]  mt-4 mb-3 mx-0"
                    style={{ width: 224 }}
                />
                <div>
                    <div className="flex items-start mx-0 my-2">
                        <sup className="text-xs mr-1.5 mt-2">1</sup>
                        <span style={{ fontSize: '12px' }}>
                            When an individual tank has more machines than can
                            be operated simultaneously, as described in the
                            Operations and Equipment Manual, then the section
                            being crude oil washed should be identified, e.g.
                            No.2 centre, forward section.
                        </span>
                    </div>
                    <div className="flex items-start mx-0 my-2">
                        <sup className="text-xs mr-1.5 mt-2">2</sup>
                        <span style={{ fontSize: '12px' }}>
                            In accordance with the Operations and Equipment
                            Manual, enter whether single-stage or multi-stage
                            method of washing is employed. If multi-stage method
                            is used, give the vertical arc covered by the
                            machines and the number of times that arc is covered
                            for that particular stage of the programme.
                        </span>
                    </div>
                    <div className="flex items-start mx-0 my-2">
                        <sup className="text-xs mr-1.5 mt-2">3</sup>
                        <span style={{ fontSize: '12px' }}>
                            If the programmes given in the Operations and
                            Equipment Manual are not folowed, then the reasons
                            must be given under Remarks.
                        </span>
                    </div>
                </div>
            </div>
            {/* Fourth Page */}
            <div className="px-8 py-0 mt-4 newpage">
                <ol type="A" className="ml-4 list-alpha" start={5}>
                    <li className="mb-6">
                        <b>Ballasting of cargo tanks</b>
                        <ol className="ml-4 list-decimal" start={18}>
                            <li className="mx-0 my-2">
                                Position of ship at start and end of ballasting.
                            </li>
                            <li className="mx-0 my-2">
                                Ballasting process:
                                <ol className="ml-4 list-decimal">
                                    <li className="mx-0 my-2">
                                        identity of tank(s) ballasted;
                                    </li>
                                    <li className="mx-0 my-2">
                                        time of start and end; and
                                    </li>
                                    <li className="mx-0 my-2">
                                        quantity of ballast received. Indicate
                                        total quantity of ballast for each tank
                                        involved in operation, in m³.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                    <li className="mb-6">
                        <b>
                            {' '}
                            Ballasting of dedicated clean ballast tanks (CBT
                            tankers only)
                        </b>
                        <ol className="ml-4 list-decimal" start={20}>
                            <li className="mx-0 my-2">
                                Identity of tank(s) ballasted.
                            </li>
                            <li className="mx-0 my-2">
                                Position of ship when water intended for
                                flushing, or port ballast was taken to dedicated
                                clean ballast tank(s).
                            </li>
                            <li className="mx-0 my-2">
                                Position of ship when pump(s) and lines were
                                flushed to slop tank.
                            </li>
                            <li className="mx-0 my-2">
                                Quantity of the oily water which, after line
                                flushing, is transferred to the slop tank(s) or
                                cargo tank(s) in which slop is preliminarily
                                stored (identify tank(s)). State total quantity,
                                in m³
                            </li>
                            <li className="mx-0 my-2">
                                Position of ship when additional ballast water
                                was taken to dedicated clean ballast tank(s)
                            </li>
                            <li className="mx-0 my-2">
                                Time and position of ship when valves separating
                                the dedicated clean ballast tanks from cargo and
                                stripping lines were closed.
                            </li>
                            <li className="mx-0 my-2">
                                Quantity of clean ballast taken on board, in m³.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-6">
                        <b>Cleaning of cargo tanks</b>
                        <ol className="ml-4 list-decimal" start={27}>
                            <li className="mx-0 my-2">
                                Identity of tank(s) cleaned.
                            </li>
                            <li className="mx-0 my-2">
                                Port or ship's position.
                            </li>
                            <li className="mx-0 my-2">Duration of cleaning.</li>
                            <li className="mx-0 my-2">
                                Method of cleaning.
                                <sup className="text-xs">4</sup>
                            </li>
                            <li className="mx-0 my-2">
                                Tank washings transferred to:
                                <ol className="ml-4 list-decimal">
                                    <li className="mx-0 my-2">
                                        reception facilities (state port and
                                        quantity, in m³){' '}
                                        <sup className="text-xs">5</sup> ; and
                                    </li>
                                    <li className="mx-0 my-2">
                                        sloptank(s) or cargo tank(s) designated
                                        as sloptank(s) (identify tank(s); state
                                        quantity transferred and total quantity,
                                        in m³).
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                </ol>
                <div
                    className=" border-[#2D3748] border-[0.5px]  mt-3 mx-0"
                    style={{ width: 224 }}
                ></div>
                <div>
                    <div className="flex items-start mx-0 my-2">
                        <sup className="text-xs mr-1.5 mt-2">4</sup>
                        <span style={{ fontSize: '12px' }}>
                            Hand-hosing, machine washing and/or chemical
                            cleaning. Where chemically cleaned, the chemical
                            concerned and amount used should be stated.
                        </span>
                    </div>
                    <div className="flex items-start mx-0 my-2">
                        <sup className="text-xs mr-1.5 mt-2">5</sup>
                        <span style={{ fontSize: '12px' }}>
                            Ships' masters should obtain from the operator of
                            the reception facilities, which include barges and
                            tank trucks, a receipt or certificate detailing the
                            quantity or tank washings, dirty ballast, residues
                            or oily mixtures transfered together with the time
                            and date or the transfer. This receipt or
                            certificate, if attached to the Oil Record Book Part
                            II, may aid the master of the ship in proving that
                            his ship was not involved in an alleged pollution
                            incident. The receipt or the certificate should be
                            kept together with the Oil Record Book Part II.
                        </span>
                    </div>
                </div>
            </div>
            {/* Fifth page */}
            <div className="px-8 py-4 mt-4 newpage">
                <ol type="A" className="ml-4 list-alpha" start={8}>
                    <li className="mb-8">
                        <b>Discharge of dirty ballast</b>
                        <ol className="ml-4 list-decimal" start={32}>
                            <li className="mx-0 my-2">Identity of tank(s).</li>
                            <li className="mx-0 my-2">
                                Time and position of ship at start of discharge
                                into the sea.
                            </li>
                            <li className="mx-0 my-2">
                                Time and position of ship on completion of
                                discharge into sea.
                            </li>
                            <li className="mx-0 my-2">
                                Quantity discharged into the sea, in m³.
                            </li>
                            <li className="mx-0 my-2">
                                Ship's speed(s) during discharge.
                            </li>
                            <li className="mx-0 my-2">
                                Was the discharge monitoring and control system
                                in operation during the discharge?
                            </li>
                            <li className="mx-0 my-2">
                                Was a regular check kept on the effluent and the
                                surface of the water in the locality of the
                                discharge?
                            </li>
                            <li className="mx-0 my-2">
                                Quantity of oily water transferred to slop
                                tank(s) (identify slop tank(s). State total
                                quantity, in m³)
                            </li>
                            <li className="mx-0 my-2">
                                Discharged to shore reception facilities
                                (identify port and quantity involved, in m³).{' '}
                                <sup style={{ fontSize: 10 }}>5</sup>
                            </li>
                        </ol>
                    </li>
                    <li className="mb-8">
                        <b>Discharge of water from slop tanks into the sea</b>
                        <ol className="ml-4 list-decimal" start={41}>
                            <li className="mx-0 my-2">
                                Identity of slop tanks.
                            </li>
                            <li className="mx-0 my-2">
                                Time of settling from last entry of residues, or
                            </li>
                            <li className="mx-0 my-2">
                                Time of settling from last discharge.
                            </li>
                            <li className="mx-0 my-2">
                                Time and position of ship at start of discharge
                            </li>
                            <li className="mx-0 my-2">
                                Ullage of total contents at start of discharge.
                            </li>
                            <li className="mx-0 my-2">
                                Ullage of oil/water interface at start of
                                discharge.
                            </li>
                            <li className="mx-0 my-2">
                                Bulk quantity discharged, in m³ and rate of
                                discharge, in m³/hour.
                            </li>
                            <li className="mx-0 my-2">
                                Final quantity discharged, in m³ and rate of
                                discharge, in m³/hour.
                            </li>
                            <li className="mx-0 my-2">
                                Time and position of ship on completion of
                                discharge.
                            </li>
                            <li className="mx-0 my-2">
                                Was the discharge monitoring and control system
                                in operation during the discharge?
                            </li>
                            <li className="mx-0 my-2">
                                Ullage of oil/ water interface on completion of
                                discharge, in metres.
                            </li>
                            <li className="mx-0 my-2">
                                Ship's speed(s) during discharge.
                            </li>
                            <li className="mx-0 my-2">
                                Was regular check kept on the effluent and the
                                surface of water in the locality of the
                                discharge?
                            </li>
                            <li className="mx-0 my-2">
                                Confirm that all applicable valves in the ship's
                                piping system have been closed on completion of
                                discharge from the slop tanks.
                            </li>
                        </ol>
                    </li>
                </ol>
                <div
                    className=" border-[#2D3748] border-[0.5px]  mt-0 mb-4 mx-0"
                    style={{ width: 224 }}
                ></div>
                <div>
                    <div className="flex items-start mx-0 my-2">
                        <sup className="text-xs mr-1.5 mt-2">5</sup>
                        <span style={{ fontSize: '12px' }}>
                            Ships' masters should obtain from the operator of
                            the reception facilities, which include barges and
                            tank trucks, a receipt or certificate detailing the
                            quantity or tank washings, dirty ballast, residues
                            or oily mixtures transferred together with the time
                            and date or the transfer. This receipt or
                            certificate, if attached to the Oil Record Book Part
                            ,II may aid the master of the ship in proving that
                            his ship was not involved in an alleged pollution
                            incident. The receipt or the certificate should be
                            kept together with the Oil Record Book Part II.
                        </span>
                    </div>
                </div>
            </div>
            {/* Sixth Page */}
            <div className="px-8 py-4 newpage">
                <ol type="A" className="ml-4 list-alpha" start={10}>
                    <li className="mb-8">
                        <b>
                            Collection, transfer and disposal of residues and
                            oily mixtures not otherwise dealt with
                        </b>
                        <ol className="ml-4 list-decimal" start={55}>
                            <li className="mx-0 my-2">Identity of tanks.</li>
                            <li className="mx-0 my-2">
                                Quantity transferred or disposed of from each
                                tank. (State the quantity retained, in m³.)
                            </li>
                            <li>
                                Method of transfer or disposal:
                                <ol className="mx-0 my-2 ml-4 list-decimal">
                                    <li className="mx-0 my-2">
                                        disposal to reception facilities
                                        (identify port and quantity involved)
                                        <sup style={{ fontSize: 10 }}>5</sup> ;
                                    </li>
                                    <li className="mx-0 my-2">
                                        mixed with cargo (state quantity):
                                    </li>
                                    <li className="mx-0 my-2">
                                        transferred to or from (an)other tank(s)
                                        including transfer from machinery space
                                        oil residue (sludge) and oily bilge
                                        water tanks(identify tank(s); state
                                        quantity transferred and total quantity
                                        in tank(s), in m³); and
                                    </li>
                                    <li className="mx-0 my-2">
                                        other method (state which); state
                                        quantity disposed of, in m³.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                    <li className="mb-8">
                        <b>
                            {' '}
                            Discharge of clean ballast contained in cargo tanks
                        </b>
                        <ol className="ml-4 list-decimal" start={58}>
                            <li className="mx-0 my-2">
                                Position of ship at start of clean ballast.
                            </li>
                            <li className="mx-0 my-2">
                                Identity of tank(s) discharged.
                            </li>
                            <li className="mx-0 my-2">
                                Was (were) the tank(s) empty on completion?
                            </li>
                            <li className="mx-0 my-2">
                                Position of ship on completion if different from
                                58.
                            </li>
                            <li className="mx-0 my-2">
                                Was a regular check kept on the effluent and the
                                surface of the water in the locality of the
                                discharge?
                            </li>
                        </ol>
                    </li>
                    <li className="mb-8">
                        <b>
                            {' '}
                            Discharge of ballast from dedicated clean ballast
                            tanks (CBT tankers only)
                        </b>
                        <ol className="ml-4 list-decimal" start={63}>
                            <li className="mx-0 my-2">
                                Identity of tank(s) discharged.
                            </li>
                            <li className="mx-0 my-2">
                                Time and position of ship at start of discharge
                                of clean ballast into the sea.
                            </li>
                            <li className="mx-0 my-2">
                                Time and position of ship on completion of
                                discharge into the sea.
                            </li>
                            <li className="mx-0 my-2">
                                Quantity discharged, in m³:
                                <ol className="ml-4 list-decimal">
                                    <li className="mx-0 my-1">
                                        into the sea; or
                                    </li>
                                    <li className="mx-0 my-1">
                                        to reception facility (identify port).{' '}
                                        <sup className="text-xs">5</sup>
                                    </li>
                                </ol>
                            </li>
                            <li className="mx-0 my-2">
                                Was there any indication of oil contamination of
                                the ballast water before or during discharge
                                into the sea?
                            </li>
                        </ol>
                    </li>
                </ol>
                <div
                    className=" border-[#2D3748] border-[0.5px] my-3 mx-0"
                    style={{ width: 224 }}
                ></div>
                <div>
                    <div className="flex items-start mx-0 my-2">
                        <sup className="text-xs mr-1.5 mt-2">5</sup>
                        <span style={{ fontSize: '12px' }}>
                            Ships' masters should obtain from the operator of
                            the reception facilities, which include barges and
                            tank trucks, a receipt or certificate detailing the
                            quantity or tank washings, dirty ballast, residues
                            or oily mixtures transferred together with the time
                            and date or the transfer. This receipt or
                            certificate, if attached to the Oil Record Book Part
                            ,II may aid the master of the ship in proving that
                            his ship was not involved in an alleged pollution
                            incident. The receipt or the certificate should be
                            kept together with the Oil Record Book Part II.
                        </span>
                    </div>
                </div>
            </div>
            {/* Seventh Page */}
            <div className="px-8 py-4 mt-4 newpage">
                <ol className="mb-8 ml-8 list-decimal" start={68}>
                    <li className="mx-0 my-2">
                        Was the discharge monitored by an oil content meter?
                    </li>
                    <li className="mx-0 my-2">
                        Time and position of ship when valves separating
                        dedicated clean ballast tanks from the cargo and
                        stripping lines were closed on completion of
                        deballasting.
                    </li>
                </ol>
                <ol type="A" className="ml-4 list-alpha" start={13}>
                    <li className="mb-8">
                        <b>
                            Condition of oil discharge monitoring and control
                            system
                        </b>
                        <ol className="ml-4 list-decimal" start={70}>
                            <li className="mx-0 my-2">
                                Time of system failure.
                            </li>
                            <li className="mx-0 my-2">
                                Time when system has been made operational.
                            </li>
                            <li className="mx-0 my-2">Reasons for failure.</li>
                        </ol>
                    </li>
                    <li className="mb-8">
                        <b>Accidental or other exceptional discharges of oil</b>
                        <ol className="ml-4 list-decimal" start={73}>
                            <li className="mx-0 my-2">Time of occurrence.</li>
                            <li className="mx-0 my-2">
                                Port or ship's position at time of occurrence.
                            </li>
                            <li className="mx-0 my-2">
                                Approximate quantity, in m³, and type of oil.
                            </li>
                            <li className="mx-0 my-2">
                                Circumstances of discharge or escape, the
                                reasons therefor and general remarks.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-4">
                        <b>
                            Additional operational procedures and general
                            remarks
                        </b>
                    </li>
                </ol>
                <p className="m-0 mb-2 ml-6 italic">
                    TANKERS ENGAGED IN SPECIFIC TRADES
                </p>
                <ol type="A" className="ml-4 list-alpha" start={16}>
                    <li className="mb-8">
                        <b>Loading of ballast water</b>
                        <ol className="ml-4 list-decimal" start={77}>
                            <li className="mx-0 my-2">
                                Identity of tank(s) ballasted.
                            </li>
                            <li className="mx-0 my-2">
                                Position of ship when ballasted.
                            </li>
                            <li className="mx-0 my-2">
                                Total quantity of ballast loaded in cubic
                                metres.
                            </li>
                            <li className="mx-0 my-2">Remarks.</li>
                        </ol>
                    </li>
                    <li className="mb-8">
                        <b>Re-allocation of ballast water within the ship</b>
                        <ol className="ml-4 list-decimal" start={81}>
                            <li className="mx-0 my-2">
                                Reason for re-allocation.
                            </li>
                        </ol>
                    </li>
                    <li className="mb-8">
                        <b> Ballast water discharge to reception facility</b>
                        <ol className="ml-4 list-decimal" start={82}>
                            <li className="mx-0 my-2">
                                Port(s) where ballast water was discharged.
                            </li>
                            <li className="mx-0 my-2">
                                Name or designation of reception facility.
                            </li>
                            <li className="mx-0 my-2">
                                Total quantity of ballast water discharged in
                                cubic metres.
                            </li>
                            <li className="mx-0 my-2">
                                Date, signature and stamp of port authority
                                official.
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
    const dateRange = inspectorSelectors.getDateRange(inspectorStore);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    return {
        dateRange,
        vesselName: vesselInfo.vesselName,
        imoNumber: vesselInfo.imoNumber,
        tonnage: vesselInfo.tonnage,
        distinctiveNumberOrLetters: vesselInfo?.distinctiveNumberOrLetters,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ORB4CoverPage);
